import React from 'react'
import OrderListItem from './OrderListItem'

export default function OrderList({ orders, fetchOrderDetail, orderDetail, action, workingStatus, orderIdSelected }) {
  return (
    <ul className="timeline" style={{ overflowY: 'scroll', maxHeight: 'calc(100vh - 360px)' }}>
      {orders &&
        orders.map((order, i) => (
          <li key={i} onClick={() => fetchOrderDetail(order)}>
            <OrderListItem
              order={order}
              orderDetail={orderDetail}
              orderIdSelected={orderIdSelected}
              action={action}
              workingStatus={workingStatus}
            />
          </li>
        ))}
    </ul>
  )
}
